var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"product_sh_mask"}),_vm._v(" "),_c('div',{staticClass:"product_sh"},[_vm._t("default"),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"javascript:void(0);","title":"close"},on:{"click":_vm.close}},[_vm._v("close")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6d6778","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlidePopup.vue
// module id = null
// module chunks = 